import { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import {
    FormGroup,
    FormControlLabel,
    Checkbox,
    Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast, Slide } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from "../../../GlobalFunction/CrudButtons";
import axiosInstance from "../../../lib/axios";
import { useReactToPrint } from "react-to-print";
import ReportTable from "../../../atoms/ReportFolder/ReportTable";

// Define columns for the print table
const columns = [
    { id: "RowNum", label: "Sr.No.", minWidth: 5 },
    { id: "ChkArtCatName", label: "Category", minWidth: 100 },
    { id: "Abrv", label: "Abbreviation", minWidth: 50 },
    { id: "Remark", label: "Remark", minWidth: 100 },
    { id: "Status", label: "Status", minWidth: 50 },
];

const ArticleCategory = () => {
    const { register, setValue, reset, watch, getValues } = useForm({
        defaultValues: {
            ChkArtCatName: "",
            Abrv: "",
            Remark: "",
            Status: "1",
        },
    });

    const [UserId] = useState(sessionStorage.getItem("UserId"));
    const [ChkArtCatId, setChkArtCatId] = useState(-1);
    const [Mode, setMode] = useState("add");
    const [TransactionData, setTransactionData] = useState([]);
    const [OpenDForDelete, setOpenDForDelete] = useState(false);
    const [AllDisUnable, setAllDisUnable] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();

    const contentRef = useRef(null);
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const handlePrint = useReactToPrint({ contentRef });

    useEffect(() => {
        const fetchData = async () => {
            await fetchDashboardData();

            if (location.state) {
                setAllDisUnable(false);
                let ChkArtCatId = location.state.ChkArtCatId;
                setChkArtCatId(ChkArtCatId);
                await fetchArticleCatData(ChkArtCatId, "R");
            } else {
                setMode("add");
                setAllDisUnable(true);
                resetFunc();
            }
        };

        fetchData();
    }, [location.state]);

    useEffect(() => {
        if (TransactionData.length > 0 && Mode !== "add") {
            const obj = TransactionData[0];
            setValue("ChkArtCatName", obj.ChkArtCatName || "");
            setValue("Abrv", obj.Abrv || "");
            setValue("Remark", obj.Remark || "");
            setValue("Status", obj.Status || "1");
            setAllDisUnable(false);
        }
    }, [TransactionData, Mode, setValue, getValues]);

    const fetchDashboardData = async () => {
        try {
            const res = await axiosInstance.post("MstChkArtCat/getMstChkArtCatDashBoard", {
                start: 4,
                PageSize: 0,
                SearchText: "",
            });
            if (res.data && res.data.Data) {
                setRows(res.data.Data);
                setDataForPrint(res.data.Data);
            } else {
                setRows([]);
                setDataForPrint({});
            }
        } catch (err) {
            toast.error("Error fetching dashboard data");
        }
    };

    const fetchArticleCatData = async (ChkArtCatId, Flag) => {
        try {
            const response = await axiosInstance.post(`MstChkArtCat/RetriveMstChkArtCat`, {
                ChkArtCatId,
                Flag,
            });

            if (response.data.Status === 0) {
                if (Flag === "D") {
                    toast.success(response.data.Message, { autoClose: 1000 });
                    fetchArticleCatData(ChkArtCatId, "L");
                    return;
                }
                let Data = response.data.Data != null ? response.data.Data : [];
                setTransactionData(Data);
                setChkArtCatId(response.data.Data[0].ChkArtCatId);
                setMode("view");
            } else {
                if (Flag !== "D") {
                    setChkArtCatId(-1);
                    setMode("add");
                    resetFunc();
                }
                toast.info(response.data.Message);
            }
        } catch (error) {
            toast.error("Error fetching Transaction data:", error);
        }
    };

    const handleAddClick = () => {
        setMode("add");
        setAllDisUnable(true);
        resetFunc();
    };

    const handleEditClick = async () => {
        let Flag = await checkAndLock(ChkArtCatId, "MstChkArtCat", "ChkArtCatId");
        switch (Flag) {
            case 0:
                setMode("edit");
                setAllDisUnable(true);
                break;
            case 1:
                toast.info("Record Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default:
                toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    const handleCancelDButton = () => {
        setOpenDForDelete(false);
    };

    const handleSubmitClick = async () => {
        const Obj = getValues();
        if (!Obj.ChkArtCatName) {
            toast.info("Please Fill Required Field!");
            return;
        }

        let Payload = {
            ChkArtCatName: Obj.ChkArtCatName,
            Abrv: Obj.Abrv,
            Remark: Obj.Remark,
            Status: Obj.Status,
            CreatedBy: parseInt(UserId),
        };

        if (Mode === "add") {
            try {
                const response = await axiosInstance.post(
                    `MstChkArtCat/InsertMstChkArtCat`, Payload
                );

                if (response.data.Status === 0) {
                    toast.success(response.data.Message, { autoClose: 1000 });
                    fetchArticleCatData(1, "L");
                    setMode("view");
                    setAllDisUnable(false);
                } else {
                    toast.info(response.data.Message);
                }
            } catch (error) {
                toast.error("Error inserting data:", error);
            }
        } else {
            Payload = { ...Payload, ChkArtCatId, UpdatedBy: parseInt(UserId) };
            delete Payload.CreatedBy;

            try {
                const response = await axiosInstance.post(
                    `MstChkArtCat/UpdateMstChkArtCat`, Payload
                );

                if (response.data.Status === 0) {
                    toast.success(response.data.Message, { autoClose: 1000 });
                    await UnLock(ChkArtCatId, "MstChkArtCat", "ChkArtCatId");
                    fetchArticleCatData(ChkArtCatId, "R");
                    setAllDisUnable(false);
                } else {
                    toast.info(response.data.Message);
                }
            } catch (error) {
                toast.error("Error updating data:", error);
            }
        }
    };

    const handleCancelClick = async () => {
        if (ChkArtCatId === -1 && Mode === "add") {
            await fetchArticleCatData(1, "L");
        } else {
            await UnLock(ChkArtCatId, "MstItmGrp", "ChkArtCatId");
            await fetchArticleCatData(ChkArtCatId, "R");
        }
    };

    const handleCategoryChange = (event, newValue) => {
        const selectedId = newValue ? newValue.Id : "";
        setValue("ItmCatId", selectedId, { shouldValidate: true });
    };

    const handleDeleteClick = () => {
        setOpenDForDelete(true);
    };

    const handleClickBackToTable = () => {
        navigate("/articlecategorytable");
    };

    const handleConfirmDDelete = () => {
        fetchArticleCatData(ChkArtCatId, "D");
        setOpenDForDelete(false);
    };

    const handleNextClick = () => {
        fetchArticleCatData(ChkArtCatId, "N");
    };

    const handlePrevClick = () => {
        fetchArticleCatData(ChkArtCatId, "P");
    };

    const resetFunc = () => {
        reset({
            ChkArtCatName: "",
            Abrv: "",
            Remark: "",
            Status: "1",
        });
    };

    const handleCheckBoxChange = () => {
        setValue("Status", watch("Status") === "1" ? "0" : "1", { shouldValidate: true });
    };

    return (
        <Box className="form-container" sx={{ height: { xs: "700px", sm: "550px" } }}>
            <Dialog
                open={OpenDForDelete}
                onClose={handleCancelDButton}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Do You Want To Delete The Unit ?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description"></DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: "#635bff",
                            color: "white",
                            "&:hover": {
                                backgroundColor: "#1565c0",
                                color: "white",
                            },
                        }}
                        onClick={handleConfirmDDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: "#635bff",
                            color: "white",
                            "&:hover": {
                                backgroundColor: "#1565c0",
                                color: "white",
                            },
                        }}
                        onClick={handleCancelDButton}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>

            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Slide}
            />

            <Grid container spacing={2} className="form_grid">
                <Grid
                    item
                    xs={12}
                    className="form_title"
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginTop: "20px",
                        flexDirection: { xs: "column", sm: "row", md: "row" },
                    }}
                >
                    <Grid
                        sx={{
                            display: "flex",
                            justifyContent: { xs: "center", sm: "flex-start" },
                            marginBottom: { xs: "10px", sm: 0 },
                        }}
                    >
                        <Button
                            variant="contained"
                            size="small"
                            className="three-d-button-previous"
                            sx={{
                                backgroundColor: "#635BFF",
                                marginRight: { xs: "5px", sm: "10px" },
                                display: { xs: "none", sm: "block" },
                            }}
                            onClick={handlePrevClick}
                            disabled={AllDisUnable}
                        >
                            <KeyboardArrowLeftIcon />
                        </Button>

                        <Button
                            variant="contained"
                            size="small"
                            className="three-d-button-next"
                            sx={{
                                backgroundColor: "#635BFF",
                                display: { xs: "none", sm: "block" },
                            }}
                            onClick={handleNextClick}
                            disabled={AllDisUnable}
                        >
                            <NavigateNextIcon />
                        </Button>
                    </Grid>

                    <Typography
                        variant="h5"
                        sx={{
                            margin: "Auto",
                            textAlign: { xs: "center", sm: "center" },
                            fontSize: { xs: "24px", sm: "18px", md: "24px" },
                        }}
                    >
                        Checkin Article Category
                    </Typography>

                    <Grid sx={{ display: "flex", justifyContent: "end" }}>
                        <CrudButtons
                            moduleName="Checkin Article Category"
                            mode={Mode}
                            onAdd={handleAddClick}
                            onEdit={handleEditClick}
                            onView={handlePrint}
                            onDelete={handleDeleteClick}
                            onExit={handleClickBackToTable}
                            readOnlyMode={!AllDisUnable}
                            onPrevious={handlePrevClick}
                            onNext={handleNextClick}
                        />
                    </Grid>
                </Grid>

                <Grid item xs={12} md={10} className="form_field" sx={{ marginX: "auto" }}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={5}>
                            <TextField
                                id="ChkArtCatName"
                                name="ChkArtCatName"
                                label={
                                    <span>
                                        Checkin Article Category <span style={{ color: "red" }}>*</span>
                                    </span>
                                }
                                value={watch("ChkArtCatName") || ""}
                                {...register("ChkArtCatName")}
                                variant="filled"
                                fullWidth
                                className="custom-textfield"
                                disabled={!AllDisUnable}
                            />
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <TextField
                                id="Abrv"
                                name="Abrv"
                                label="Abbreviation/Code"
                                variant="filled"
                                fullWidth
                                className="custom-textfield"
                                value={watch("Abrv") || ""}
                                {...register("Abrv")}
                                disabled={!AllDisUnable}
                            />
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <TextField
                                id="Remark"
                                name="Remark"
                                label="Remark"
                                variant="filled"
                                fullWidth
                                className="custom-textfield"
                                value={watch("Remark") || ""}
                                {...register("Remark")}
                                disabled={!AllDisUnable}
                            />
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            disabled={!AllDisUnable}
                                            name="Status"
                                            checked={watch("Status") === "1"}
                                            onChange={handleCheckBoxChange}
                                        />
                                    }
                                    label="Status"
                                />
                            </FormGroup>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} className="form_button">
                    <Button
                        variant="contained"
                        sx={{
                            mr: 1,
                            background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                        }}
                        onClick={handleSubmitClick}
                        disabled={!AllDisUnable}
                    >
                        Submit
                    </Button>
                    <Button
                        variant="contained"
                        sx={{
                            mr: 1,
                            background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                        }}
                        onClick={handleCancelClick}
                        disabled={!AllDisUnable}
                    >
                        Cancel
                    </Button>
                </Grid>
            </Grid>

            {/* Hidden Print Section */}
            <div style={{ display: "none" }}>
                {Object.keys(DataForPrint).length > 0 && (
                    <ReportTable
                        columns={columns}
                        rows={rows}
                        title="Article Category"
                        contentRef={contentRef}
                        customStyles={{ backgroundColor: "#f5f5f5" }}
                    />
                )}
            </div>
        </Box>
    );
};

export default ArticleCategory;
